const teamData = [
    {
        id:1,
        img: require('../images/team/GaryBlue.png'),
        name: 'Gary Colleran',
        role: 'CEO'
    },
    {
        id:2,
        img: require('../images/team/IanBlue.png'),
        name: 'Ian Johnson',
        role: 'President'
    },
    {
        id:3,
        img: require('../images/team/HelenBlue.png'),
        name: 'Helen Littlewood',
        role: 'President Global Learning & Development Solutions'
    },
    {
        id:4,
        img: require('../images/team/AnnieBlue.png'),
        name: 'Annie Dingley',
        role: 'Vice President Global Learner Experience Design'
    },
    {
        id:5,
        img: require('../images/team/TracyBlue.png'),
        name: 'Tracy Crawford',
        role: 'Operational Excellence'
    },
    {
        id:6,
        img: require('../images/team/JulieBlue.png'),
        name: 'Julie Coppola',
        role: 'Director of Projects and Events'
    },
    {
        id:7,
        img: require('../images/team/DavidBlue.png'),
        name: 'David Barwick',
        role: 'Vice President Global Learning & Development Solutions'
    },
    {
        id:8,
        img: require('../images/team/MarkBlue.png'),
        name: 'Mark Wilson',
        role: 'Vice President Global Learning & Development Solutions'
    },
    {
        id:9,
        img: require('../images/team/CarolineBlue.png'),
        name: 'Caroline Lewis',
        role: 'Admin Support'
    },
    {
        id:10,
        img: require('../images/team/RitaBlue.png'),
        name: 'Rita Lewis',
        role: 'Head of Accounts'
    }
]

export default teamData;